import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import EmailIcon from "@material-ui/icons/Email";
import LandingPageHeader from "../../LandingPage/views/LandingPageHeader";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { ValidateUserEmail } from "../helper/forgotPasswordHelper";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    marginTop: "10%",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  subtitle1: {
    fontSize: 13,
  },
}));

export default function ForgotPassword() {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [state, setState] = useState({
    user_email: "",
  });
  const history = useHistory();

  const handleInputChange = (e) => {
    const { value } = e.target;
    setState({
      ...state,
      user_email: value,
    });
  };

  const validate = (fieldValues = state) => {
    let temp = { ...errors };
    if ("user_email" in fieldValues) {
      temp.user_email =
        fieldValues.user_email === ""
          ? "Email Address is required"
          : /$^|.+@.+..+/.test(fieldValues.user_email)
          ? ""
          : "Invalid Email.";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      ValidateUserEmail(state);
    }
  };

  return (
    <React.Fragment>
      <LandingPageHeader />
      <Container component="main" justifycontent="center">
        <div className="Containerstyle">
          <Container
            direction="column"
            component="main"
            justifycontent="center"
            maxWidth="xs"
            className={classes.Appcss}
          >
            <CssBaseline />
            <div className={classes.paper}>
              <Avatar className={classes.avatar} style={{ backgroundColor: "rgb(22, 177, 255)" }}>
                <EmailIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                We need to verify your identity
              </Typography>
              <form className={classes.form} onSubmit={HandleSubmit}>
                <Typography className={classes.subtitle1} align="center">
                  Please enter your email id to receive password reset link
                </Typography>
                <TextField
                  autoFocus
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  label="User Id or Email"
                  name="email"
                  autoComplete="email"
                  onChange={handleInputChange}
                  value={state.user_email}
                  {...(errors.user_email && {
                    error: true,
                    helperText: errors.user_email,
                  })}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{ backgroundColor: "rgb(22, 177, 255)" }}
                >
                  Send Verification Link
                </Button>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="default"
                  onClick={() => history.push("/")}
                >
                  Cancel
                </Button>
              </form>
            </div>
          </Container>
        </div>
      </Container>
      <LandingPageFooter />
    </React.Fragment>
  );
}
